function showLoading () {
  // store.commit('setLoading', true)
}
function hiddenLoading () {
  // store.commit('setLoading', false)
}

export default {
  showLoading,
  hiddenLoading
}